import * as React from "react";
import { connect } from "react-redux";
import VipRegPay from '@mailvip/reg-pay/dist/index.esm.js';
import Modal from "../Modal";
import globalAction from '../../actions/global';
import {isPcClient} from '../../enums/enum';
import {getQueryString} from '../../utils/util';

class RegModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showHeader: true
        };
    }
    componentDidMount() {
        const that = this;
        const utm_source = getQueryString('utm_source');
        const {onRegSuc} = this.props;
        
        new VipRegPay({
            includeBox: 'regWrap',
            packageType: 'v200',
            beSource: 'vip_2020618_zc',
            utmSource: utm_source || '200618',
            initReady: function() {
                // do something
            },
            onProcess: function(step) {
                that.setState({
                    showHeader: step === 'reg'
                });
            },
            onPaySuc: function() {
                onRegSuc && onRegSuc();
            }
        });
        
    }
    __onClose() {
        const {onClose, toggleRegModal} = this.props;
        toggleRegModal(false);
        onClose && onClose();
    }
    __setPayModalData() {

    }
    render() {
        const {isRegModalVisible} = this.props;
        const { showHeader } = this.state;
        let title = '';
        if(isPcClient) {
            title = '注册VIP邮箱，翻牌赢Mate30 Pro'
        }
        return (
            <Modal isOpen={isRegModalVisible} title={title} className="w-reg-modal" onClose={this.__onClose.bind(this)}>
                {
                    !isPcClient && <div className="m-regSubTitle">注册VIP邮箱<br/>翻牌赢华为Mate30 Pro</div>
                }
                <div className="m-regModal-wrap">
                    {
                        isPcClient ? <div className="m-regModal-hd">
                            <div className="m-regModal-title">网易VIP邮箱，专享多项功能特权，办公首选<span className="m-regModal-title_sub">（45元/月，提供发票）</span></div>
                            <div className="m-regModal-privilege">
                                <ul className="f-clear">
                                    <li className="m-privilege-item ">
                                        <div className="m-privilege-item-hd m-privilege-1"></div>
                                        <div className="m-privilege-item-bd">VIP域名</div>
                                    </li>
                                    <li className="m-privilege-item">
                                        <div className="m-privilege-item-hd m-privilege-2"></div>
                                        <div className="m-privilege-item-bd">无限容量</div>
                                    </li>
                                    <li className="m-privilege-item">
                                        <div className="m-privilege-item-hd m-privilege-3"></div>
                                        <div className="m-privilege-item-bd">误删恢复</div>
                                    </li>
                                    <li className="m-privilege-item">
                                        <div className="m-privilege-item-hd m-privilege-4"></div>
                                        <div className="m-privilege-item-bd">64G大网盘</div>
                                    </li>
                                    <li className="m-privilege-item">
                                        <div className="m-privilege-item-hd m-privilege-5"></div>
                                        <div className="m-privilege-item-bd">邮箱管家</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        :
                        <div className={['m-regModal-hd', showHeader ? '' : 'hide'].join(' ')}>
                            <div className="m-regModal-title f-clear">
                                <span>套餐：</span>
                                <span className="icon-radio-checked"></span>    
                                <span>45元/月</span>
                                <span style={{float: 'right'}}>可提供发票</span>
                            </div>
                            <div className="m-regModal-privilege">
                                <ul className="f-clear">
                                    <li className="m-privilege-item privilege-item-col-1">
                                        <div className="m-privilege-item-bd">VIP域名</div>
                                    </li>
                                    <li className="m-privilege-item privilege-item-col-2">
                                        <div className="m-privilege-item-bd">无限容量</div>
                                    </li>
                                    <li className="m-privilege-item privilege-item-col-3">
                                        <div className="m-privilege-item-bd">邮箱管家</div>
                                    </li>
                                </ul>
                                <ul className="f-clear">
                                    <li className="m-privilege-item privilege-item-col-1">
                                        <div className="m-privilege-item-bd">误删恢复</div>
                                    </li>
                                    <li className="m-privilege-item privilege-item-col-2">
                                        <div className="m-privilege-item-bd">64G大网盘</div>
                                    </li>
                                    <li className="m-privilege-item privilege-item-col-3">
                                        <div className="m-privilege-item-bd">单次群发400封</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }
                    
                    <div className="m-regModal-bd">
                        <div className="m-reg-wrap">
                            <div id="regWrap"></div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        isRegModalVisible: state.global.isRegModalVisible,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleRegModal(flag) {
            dispatch(globalAction.toggleRegModal(flag));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegModal);
